import { SHIPFINDER } from "../../actions/portal/";

export default function(state = [], action) {
  switch (action.type) {
    case SHIPFINDER:
      return [action.payload];
    default:
  }

  return state;
}
